'use client'
import { FlagProvider } from '@unleash/nextjs/client'
import { ReactElement } from 'react'

import { isDev } from '../constants'
import { useAppSelector } from '../hooks/use-app-selector'

const UnleashProvider = ({
  children,
  sessionId,
}: {
  children: ReactElement
  sessionId: string
}) => {
  const { userId } = useAppSelector((state) => state.user)

  return (
    <FlagProvider
      config={{
        refreshInterval: 15,
        environment: isDev ? 'development' : 'production',
        context: {
          userId,
          sessionId,
        },
      }}
    >
      {children}
    </FlagProvider>
  )
}

export default UnleashProvider
